// R1b-γ — Financial Payments tab. Read-only.
// Reads the same payments source contracts/deposits already write to.
// Empty state is honest — no fake receipts, no fake ACH events.
import React, { useEffect, useState } from "react";
import { api } from "../../../lib/api";
import EmptyState from "../../../components/EmptyState";
import StatusChip from "../../../components/StatusChip";
import { Receipt } from "lucide-react";

export default function FinancialPaymentsTab() {
  const [rows, setRows] = useState(null);

  useEffect(() => {
    // Prefer /payments; fall back to /crm/deposits which mirrors payment events.
    api.get("/payments")
      .then((r) => setRows(Array.isArray(r.data) ? r.data : r.data?.items || []))
      .catch(() => {
        api.get("/crm/deposits")
          .then((r) => setRows(Array.isArray(r.data) ? r.data : r.data?.items || []))
          .catch(() => setRows([]));
      });
  }, []);

  return (
    <div data-testid="financial-payments-body">
      <div className="mb-4">
        <div className="font-display font-semibold text-erf-dark text-lg">Payments</div>
        <div className="text-xs font-nav text-erf-dark/60 mt-0.5" data-testid="payments-count">
          {rows === null ? "Loading…" : `${rows.length} payment record(s) · online payments are not enabled (Stripe externally blocked)`}
        </div>
      </div>

      {rows !== null && rows.length === 0 && (
        <EmptyState icon={Receipt} title="No payment records yet" subtitle="Deposits and paid invoices will appear here when Phase 2 Contracts + Deposits workflow accepts a live payment." />
      )}

      {rows !== null && rows.length > 0 && (
        <div className="bg-white border border-erf-borderCream rounded-md overflow-x-auto">
          <table className="w-full erf-table">
            <thead className="bg-erf-creamSecondary">
              <tr>
                <th className="text-left px-3 py-2">Reference</th>
                <th className="text-left px-3 py-2">Method</th>
                <th className="text-left px-3 py-2">Amount</th>
                <th className="text-left px-3 py-2">Received</th>
                <th className="text-left px-3 py-2">Status</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((p) => (
                <tr key={p.id} className="border-t border-erf-borderCream/60" data-testid={`payment-row-${p.id}`}>
                  <td className="px-3 py-2 mono text-[11px]">{p.reference || p.stripe_intent_id || p.id?.slice(0,8)}</td>
                  <td className="px-3 py-2 font-nav">{p.method || p.payment_method || "—"}</td>
                  <td className="px-3 py-2 mono">{p.amount != null ? `$${Number(p.amount).toLocaleString()}` : "—"}</td>
                  <td className="px-3 py-2 mono text-[11px]">{p.received_at ? new Date(p.received_at).toLocaleDateString() : "—"}</td>
                  <td className="px-3 py-2"><StatusChip status={p.status || "not_configured"} /></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
